import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { LicenseService } from 'src/app/EBMSuite/services/license/license.service';
import { SIBASI_SYSTEM_APP_MODULES } from 'src/app/common/model/sibasi-system.model';

@Component({
  selector: 'app-license-subscription-check',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './license-subscription-check.component.html',
  styleUrls: ['./license-subscription-check.component.scss']
})
export class LicenseSubscriptionCheckComponent implements OnInit, OnDestroy {
  @Input() subscriptionModulesToCheck: SIBASI_SYSTEM_APP_MODULES[] = [];
  isLoading = true;
  isSubscribed = false;
  private subscriptions = new Subscription();

  constructor(private licenseService: LicenseService) {}

  ngOnInit(): void {
    this.checkIfModuleIsSubscribed();
  }

  private checkIfModuleIsSubscribed(): void {
    this.isLoading = true;
    this.subscriptions.add(
      this.licenseService.getSubscribedModules().subscribe({
        next: (res) => {
          const subscribedModules = res.result;
          this.isSubscribed = this.subscriptionModulesToCheck.some((moduleName) =>
            subscribedModules.includes(moduleName)
          );
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
